import { render } from "./QrTrash.vue?vue&type=template&id=0512290e"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QrTrash.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0512290e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0512290e', __exports__)) {
    api.reload('0512290e', __exports__)
  }
  
  module.hot.accept("./QrTrash.vue?vue&type=template&id=0512290e", () => {
    api.rerender('0512290e', render)
  })

}


export default __exports__